<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M3.5 8.1665H24.5" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
  <path d="M3.5 14H24.5" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
  <path d="M3.5 19.8335H24.5" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
</svg>
